import searchController from './search.controller';
import newsResult from './newsresult.directive';
import staffResult from './staffresult.directive';
import suggestedResult from './suggestedresult.directive';
import standardResult from './standardresult.directive';
import searchService from './search.service';
import newsSearchController from './newssearch.controller';

const moduleName = 'usc.search';

angular.module(moduleName, [])
    .directive('newsResult', newsResult)
    .directive('staffResult', staffResult)
    .directive('suggestedResult', suggestedResult)
    .directive('standardResult', standardResult)

    .service('siteSearchService', ['$http', searchService])
    .controller('siteSearchController', ['$scope', '$timeout', 'siteSearchService', '$sce', '$document', '$constants', searchController])
    .controller('newsSearchController', ['contentService', 'siteSearchService', newsSearchController]);

export default moduleName;